import * as Rx from 'rxjs';
import * as RxOp from 'rxjs/operators';

import { SUBMIT_LOGIN_FORM } from './Login.state';
import { LOGOUT } from '../../state/reducer';
import { OktaAuth } from '@okta/okta-auth-js';

export const logoutEpic = (action$, _) =>
  action$.ofType(LOGOUT).pipe(
    RxOp.flatMap((action) => {
      action.payload.navigate('/logout');
      return Rx.of({ type: 'LOGOUT_REDIRECT' });
    }),
  );

export const idpUserParams = (state) => ({
  username: state.login.forms.loginForm.email.rawValue?.toLowerCase(),
  oidc: state.config.oidc,
});

// This flow for Okta login with an external Identity Provider
// is based on the code for the Okta Signin Widget
// https://github.com/okta/okta-signin-widget/blob/27625d50ecd2fcddb6fb6b86ad503a218eb90bd8/src/models/IDPDiscovery.js#L53

const buildInputForParameter = (name, value) => {
  const input = document.createElement('input');
  input.name = name;
  input.value = decodeURIComponent(value);
  input.type = 'hidden';
  return input;
};

const idpLoginFlow = (oktaAuth, username) =>
  oktaAuth
    .webfinger({
      resource: `acct:${username}`,
      rel: 'okta:idp',
      requestContext: window.location.href,
    })
    .then((res) => {
      if (res?.links?.[0]?.href) {
        const url = new URL(res.links[0].href);
        const fragment = url.hash.substring(1);
        const query = url.search.substring(1);
        let targetUrl = url.origin + url.pathname;

        if (fragment) {
          targetUrl += '#' + fragment;
        }
        const form = document.createElement(`form`);
        form.method = 'get';
        form.setAttribute('style', 'display: none;');
        form.action = encodeURI(targetUrl);

        if (query && query.length) {
          const queryParts = query.split('&');
          queryParts.forEach((queryPart) => {
            const parameterParts = queryPart.split('=');
            const input = buildInputForParameter(
              parameterParts[0],
              parameterParts[1],
            );

            form.appendChild(input);
          });
        }
        document.body.appendChild(form);
        form.submit();
      }
    })
    .catch((err) => console.warn(`Warning: Webfinger error:`, err));

export const logInOktaUserEpic = (action$, state$) =>
  action$.ofType(SUBMIT_LOGIN_FORM).pipe(
    RxOp.mergeMap(() => {
      const { username, oidc } = idpUserParams(state$.value);
      const oktaAuth = new OktaAuth(oidc);
      idpLoginFlow(oktaAuth, username);
      return Rx.of({
        type: 'LOGIN_SUCCESS',
      });
    }),
  );
